module.exports = __webpack_public_path__ + "_/images/apps/55c989d5-855d-4538-b67b-3cdb46acd968/imagesharer-preview-tw-actions.png";